import React, { useEffect, useState } from "react";
import "./Pagination.scss";
import { GrFormPrevious, GrFormNext } from "react-icons/gr";
import { useSelector } from "react-redux";
import { getUploadedFiles } from "../../utils/services/lighthouse";

interface PaginationProps {
  orignalData: any;
  setCurrentData: any;
  itemsPerPage: number;
  type: string;
}

const Pagination: React.FC<PaginationProps> = ({
  orignalData,
  setCurrentData,
  itemsPerPage,
  type,
}) => {
  const [pageCount, setPageCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [currentType, setCurrentType] = useState<string>(type);
  const [itemOffset, setItemOffset] = useState<number>(0);
  const fileStore = useSelector((store: any) => store?.file);

  const fetchMoreFiles = async (endOffset: number) => {
    if (
      fileStore?.totalPages > fileStore?.pageNumber &&
      endOffset >= fileStore?.pageSize * fileStore?.pageNumber
    ) {
      await getUploadedFiles(fileStore?.pageNumber + 1);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      fileStore?.pageNumber === 1 && setCurrentPage(0);
    }
    return () => {
      mounted = false;
    };
  }, [fileStore]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (orignalData?.length < fileStore?.filesArr?.length) {
        setCurrentPage(0);
        setCurrentType("null");
      } else {
        setCurrentType(type);
      }
    }
    return () => {
      mounted = false;
    };
  }, [orignalData]);

  useEffect(() => {
    const newOffset = (currentPage * itemsPerPage) % (orignalData?.length || 0);
    setItemOffset(newOffset ? newOffset : 0);
  }, [currentPage, itemsPerPage, orignalData]);

  useEffect(() => {
    let componentMounted = true;
    if (orignalData?.length && componentMounted) {
      const endOffset = itemOffset + itemsPerPage;
      currentType === "files" && fetchMoreFiles(endOffset);
      setCurrentData(orignalData?.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(orignalData?.length / itemsPerPage));
    }

    return () => {
      componentMounted = false;
    };
  }, [itemOffset, itemsPerPage, orignalData, currentType, setCurrentData]);

  return (
    <div className="paginationContainer">
      <div className="paginationContainer__infoBox">
        <p>
          Showing {currentPage * itemsPerPage + 1} to{" "}
          {(currentPage + 1) * itemsPerPage > (orignalData?.length || 0)
            ? orignalData?.length
            : (currentPage + 1) * itemsPerPage}{" "}
          of{" "}
          {currentType === "files"
            ? fileStore?.totalFiles
            : orignalData?.length}{" "}
          results
        </p>
      </div>
      <div className="paginationContainer__buttonBox">
        <button
          className="prev"
          disabled={currentPage === 0}
          onClick={() => {
            setCurrentPage(currentPage - 1);
          }}
        >
          <GrFormPrevious /> &nbsp; Previous
        </button>
        <button
          className="next"
          disabled={currentPage === pageCount - 1}
          onClick={() => {
            setCurrentPage(currentPage + 1);
          }}
        >
          Next&nbsp;
          <GrFormNext />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
